import { QSFileFormValues } from "./@types";

export const INITIAL_FILE_FORM_VALUES: QSFileFormValues = {
  fileName: "",
  fileType: [],
  fromSizeNumber: "",
  fromSizeType: "MB",
  toSizeNumber: "",
  toSizeType: "MB",
  antivirusDetectionsCountFrom: "",
  antivirusDetectionsCountTo: "",
  fileTags: [],
  threatName: "",
  classification: [],
  threatScore: "",
  attackTechnique: [],
  staticAnalysisIndicators: [],
  avVendors: [],
  submissionTime: {
    label: "",
    value: ""
  }
};
